import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api/api.service';

import * as d3 from 'd3';

const TYPE_STYLES = {
  "ip": { fillColor: "#f1bf4e", borderColor: "#edae1f", icon: "\uf0ac"/*globe*/},
  "domain": { fillColor: "#86c7af", borderColor: "#36a37b", icon: "\uf233"/*server*/},
  "hash": { fillColor: "#c95c84", borderColor: "#a3365e", icon: "\uf292"/*hashtag*/},
  "user_agent": { fillColor: "#86bfc7", borderColor: "#52a3af", icon: "\uf007"/*hashtag*/},
  "default": { fillColor: "#999999", borderColor: "#cccccc", icon: "\uf128"/*question mark*/}
};

@Component({
  selector: 'app-context',
  templateUrl: './context.component.html',
  styleUrls: ['./context.component.scss']
})

export class ContextComponent implements OnInit {
  private data;
  private svg;
  private tooltip;
  private margin = 25;
  private width = 750 - (this.margin * 2);
  private height = 400 - (this.margin * 2);

  private createSvg(): void {
    this.svg = d3.select("#d3-svg")
      .attr("width", this.width + (this.margin * 2))
      .attr("height", this.height + (this.margin * 2))
      .append("g")
      .attr("transform", "translate(" + this.margin + "," + this.margin + ")");
  }

  private createTooltip(data: any): void {
    this.tooltip = d3.select("#d3-tooltip")
      .attr("class", "tooltip")
      .style("opacity", 0)
      .style("background-color", "#ffffff")
      .style("border", "solid")
      .style("border-width", "1px")
      .style("border-radius", "5px")
      .style("border-color", "#000000")
      .style("padding", "5px");
  }

  private drawGraph(data: any): void {
    const link = this.svg
      .selectAll("line")
      .data(data.links)
      .enter()
      .append("line")
      .attr("marker-end", "url(#arrow)")
      .style("stroke", "#aaa");
    
    const node = this.svg
      .selectAll("circle")
      .data(data.nodes)
      .enter()
      .append("g")
      .append("a")
      .attr("href", function (d) {
        return '/search?query=' + d.value;
      })
      .style("text-decoration", "none");
    
    node.append("circle")
      .attr("r", 25)
      .style("fill", function (d) {
        for (let t of d.type) {
          if (TYPE_STYLES[t] !== undefined)
            return TYPE_STYLES[t].fillColor;
        }
        return TYPE_STYLES['default'].fillColor;
      })
      .style("fill-opacity", 1)
      .attr("stroke", function (d) {
        for (let t of d.type) {
          if (TYPE_STYLES[t] !== undefined)
            return TYPE_STYLES[t].borderColor;
        }
        return TYPE_STYLES['default'].borderColor;
      })
      .style("stroke-width", 3)
      .style("transition", "transform 0.2s");

    node.append("text")
      .attr("dy", ".35em")
      .attr("class", "fa")
      .attr("text-anchor", "middle")
      .text(function (d) {
        for (let t of d.type) {
          if (TYPE_STYLES[t] !== undefined)
            return TYPE_STYLES[t].icon;
        }
        return TYPE_STYLES['default'].icon;
      });
    
    const tooltip = this.tooltip;
    node.on("mouseover", function(event) {
      tooltip.style("opacity", 1);
      d3.select(this)
        .select("circle")
        .style("transform", "scale(1.15)");
    })
      .on("mousemove", function(event) {
        tooltip.style("left", (d3.pointer(event, null)[0]+30) + "px")
          .style("top", (d3.pointer(event, null)[1]) + "px")
          .select("pre")
          .text(d3.select(this).datum()["value"]);
      })
      .on("mouseleave", function(event) {
        tooltip.style("opacity", 0);
        d3.select(this)
          .select("circle")
          .style("transform", "none");
      });

    const simulation = d3.forceSimulation(data.nodes)
      .force("link",
        d3.forceLink()
          .id(function(d) { return d["value"]; })
          .links(data.links)
      )
      .force("charge", d3.forceManyBody().strength(-1500))
      .force("center", d3.forceCenter(this.width / 2, this.height / 2))
      .on("tick", tick);
    
    function tick() {
      link
        .attr("x1", function(d) { return d.source.x; })
        .attr("y1", function(d) { return d.source.y; })
        .attr("x2", function(d) { return d.target.x; })
        .attr("y2", function(d) { return d.target.y; });
  
      node.attr("transform", function(d) { return "translate(" + d.x + "," + d.y + ")"; });
    }
  }

  constructor(private route: ActivatedRoute, private api: ApiService) { }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
        const query = params.query.trim();
        this.api.context(query).subscribe(response => {
          console.log(response);
          this.data = {
            nodes: response.observables,
            links: response.relationships
          };
          this.createSvg();
          this.createTooltip(this.data);
          this.drawGraph(this.data);
        });
      });
  }
}
